import React, { useState } from 'react';
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apis from '../services'; // Import your API functions (getDetails)
import styles from "./Components.module.css";
import { FaChevronDown } from "react-icons/fa6";

const CheckScam = () => {
  const [tokenAddress, setTokenAddress] = useState('');
  const [blockchain, setBlockchain] = useState('1'); 
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Blockchain to network mapping
  const blockchainToNetwork = {
    "1": "eth",
    "101": "solana",
    "56": "bsc",
    "43114": "avax",
    "137": "polygon_pos"
  };

  // Handle token address input
  const handleInputChange = (e) => {
    setTokenAddress(e.target.value);
  };

  // Handle blockchain selection
  const handleBlockchainChange = (e) => {
    setBlockchain(e.target.value);
  };

  const removeTokenAddressAndData = () => {
    localStorage.removeItem("token-address")
    localStorage.removeItem("token-data")
  }

  // Handle API Call
  
  const handleCheckScam = async () => {
    setResult(null);
    setError(null);
    setLoading(true);
    try {
      // Get network name from mapping
      const network = blockchainToNetwork[blockchain];
      if (!network) {
        toast.error('Invalid blockchain selected.');
        setError('Invalid blockchain.');
        setLoading(false);
        return;
      }

      // Make API call using getDetails function from apis.js
      const response = await apis.getDetails(tokenAddress, blockchain, network);

      if (response.status === 200) {
        setResult(response.data);
        localStorage.setItem("token-address", JSON.stringify(tokenAddress))
        localStorage.setItem("token-data", JSON.stringify(response.data))
        navigate(`/details/${tokenAddress}?checkScam=true&&chainName=${network}`, { state: { tokenData: response.data } });
      } else {
        removeTokenAddressAndData()
        toast.error('Invalid response from API');
        setError('Invalid response from API');
      }
    } catch (err) {
      removeTokenAddressAndData()
      if (err.response?.status === 404) {
        toast.error('Record not found, will get back shortly');
        setError('Token data not found.');
        // Passing error message to details page
        navigate(`/details/${tokenAddress}?checkScam=true`, { state: { error: 'Token data not found.' } });
      } else {
        toast.error(err.response?.data?.message || 'Something went wrong.');
        setError(err.response?.data?.message || 'Something went wrong. Please reload your page.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='main-invest-details'>
      <ToastContainer />

      {/* Header Section */}
      <div className="header-container">
        <div className="header-content">
          <h1 className="header-title">Lookna</h1>
          <h2 className="header-subtitle">
            FIND YOUR<span className="color-sp"> IDEAL <br />INVESTMENT</span> VAULT
          </h2>
          <p className="header-description">
            Discover a range of investment options tailored to your needs, from <br />
            automated solutions to customizable strategies
          </p>
        </div>
        <div className="details-borders"></div>
      </div>

      {/* Token Checker Section */}
      <div className="token-checker-container">
        <div className="input-section">
          <div className={styles.filterMain}>
            <div className={styles.filterChild}>
              <div className={styles.filterContainer}>
                <div className={styles.filterHeader}>
                  {/* <FaChevronDown className={styles.filterIcon} /> */}
                  {/* <span>Block Chain</span> */}
                </div>

                <div className={styles.filtersGrid}>
                  {/* Blockchain Filter */}
                  <div className={styles.filterGroup}>
                  <label style={{ color: 'gray', whiteSpace: 'nowrap' , fontWeight: "bold"}}>
  Please select your preferred chain
</label>
                    <select
                      className={styles.select}
                      value={blockchain} 
                      onChange={handleBlockchainChange} 
                    >
                      <option value="1">Ethereum</option>
                      <option value="101">Solana</option>
                      <option value="56">Binance</option>
                      <option value="43114">Avalanche</option>
                      <option value="137">Polygon</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Token Address Input */}
          <input
            type="text"
            id="token-address"
            placeholder="Token Address"
            value={tokenAddress}
            onChange={handleInputChange}
          />
        </div>

        {/* Check Scam Button */}
        <button
          className="check-scam-button"
          onClick={handleCheckScam}
          disabled={loading || !tokenAddress} // Disable when loading or no input
        >
          {loading ? (
            <span className="loading-spinner">Loading...</span>
          ) : (
            <>
              <FaExclamationTriangle className="button-icon" />
              Check Scam
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default CheckScam;
